const router = {
  path: '/search',
  name: 'Search',
  meta: { title: '认证查询', type: 'user' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/search/car/:vin',
      name: 'RnrCarSearch',
      meta: { title: '认证查询', type: 'business' },
      component: () => import('@/views/search/car')
    },
    {
      path: '/search/user',
      name: 'UserSearch',
      component: () => import('@/views/user'),
      meta: { title: '车主实名查询', type: 'user' }
    }
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/search.js